module.exports = __webpack_public_path__ + "assets/img/7553af0f767893e3c5be3c77130b0f14.png";